module.exports = __webpack_public_path__ + "img/trial3-1.cf536da8.png";